import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/dist/query";
import { attachAuthInterceptor } from "../api/apiClient";
import { modeReducer, setMode } from "./slices/modeSlice";
import {
  authReducer,
  setAuth,
  clearAuth,
  setChecked,
} from "./slices/authSlice";
import { projectsReducer } from "./slices/projectsSlice";
import { projectReducer } from "./slices/projectSlice";
import { scenariosReducer } from "./slices/scenariosSlice";
import { layersReducer } from "./slices/layersSlice";
import {
  selectedLayerReducer,
  updateSelectedLayer,
} from "./slices/selectedLayerSlice";
import { subscriptionReducer } from "./slices/subscriptionSlice";
import {
  workspaceReducer,
  setSelectedWorkspaceKey,
  clearWorkspaceState,
} from "./slices/workspaceSlice";

const errorHandlingMiddleware = (store) => (next) => (action) => {
  try {
    return next(action);
  } catch (error) {
    console.error("Middleware caught an error:", error);
    throw error;
  }
};

export const store = configureStore({
  reducer: {
    mode: modeReducer,
    auth: authReducer,
    projects: projectsReducer,
    project: projectReducer,
    scenarios: scenariosReducer,
    layers: layersReducer,
    selectedLayer: selectedLayerReducer,
    subscription: subscriptionReducer,
    workspace: workspaceReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(errorHandlingMiddleware),
});

setupListeners(store.dispatch);

attachAuthInterceptor({ store, clearAuth });

export { setMode, setAuth, clearAuth, setChecked, updateSelectedLayer };
export { setSelectedWorkspaceKey, clearWorkspaceState };
